import type { FC } from 'react';
import { CustomTooltip } from '@/app/components/shared/CustomTooltip';
import { Switch } from '@/app/components/ui/switch';
import { cn } from '@/app/utils';

export const CustomSwitch: FC<{
  className?: string;
  disabled?: boolean;
  checked?: boolean;
  onChange: (value: boolean) => void;
  label?: string;
  tooltip?: string;
  isNew?: boolean;
}> = ({ className, checked, onChange, label, tooltip, isNew, disabled }) => {
  return (
    <CustomTooltip content={tooltip} contentClassName="sm:hidden">
      <div className={cn('flex items-center space-x-1 text-system-white text-xs', className)}>
        <Switch
          id={`switch-${label}`}
          checked={checked}
          onCheckedChange={() => {
            onChange(!checked);
          }}
          disabled={disabled}
        />
        <label
          htmlFor={`switch-${label}`}
          className={cn(
            'cursor-pointer leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
            isNew &&
              'relative text-white before:absolute before:inset-0 before:z-[-1] before:bg-system-blue02 before:shadow-[inset_0_0_10px_#0086FF,inset_0_0_2.5px_#0086FF] before:blur-[7px] before:drop-shadow-[0_0_2.5px_rgba(0,134,255,0.6)]',
          )}
        >
          {label}
        </label>
      </div>
    </CustomTooltip>
  );
};
